import { FormattedMessage } from 'dibs-react-intl';

const InitiateDepositRequest = () => (
    <FormattedMessage
        id="dc.dibs-buyer-deposit.InitiateDepositRequest"
        defaultMessage="Initiate deposit request"
    />
);

export default InitiateDepositRequest;
